import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Users from '../views/Users.vue'
import MessageUser from '../views/MessageUser.vue'
import ViewUser from '@/views/ViewUser.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import AddUser from '../views/AddUser.vue'
import VoiceMessages from '../views/VoiceMessages.vue'
import BlockSettingsPage from '../views/BlockSettingsPage.vue'
import Template from '@/views/Template.vue'
import AddTemplate from '../views/AddTemplate.vue'
import Dashboard from '../views/Dashboard.vue'
import Properties from '../views/Properties.vue'
import Lease from '../views/Lease.vue'
import Tenants from '../views/Tenants.vue'
import Landlords from '../views/Landlords.vue'
import Addproperty from '../views/Addproperty.vue'
import Addtenant from '../views/Addtenant.vue'
import AddLandlords from '../views/AddLandlords.vue'
import Reports from '../views/Reports.vue'
import AddTenantsExel from '../views/AddTenantsExel.vue'

import Addlease from '../views/Addlease.vue'
import Finances from '../views/Finances.vue'
import EditLease from '../views/EditLease.vue'

import Attachments from '../views/Attachments.vue'

import LeaseReports from '../views/LeaseReports.vue'

import EditTenant from '../views/EditTenant.vue'

import EditProperty from '../views/EditProperty.vue'
import EditLandlords from '../views/EditLandlords.vue'

import TemplateName from '../views/TemplateName.vue'
import ViewTemplateDetails from '../views/ViewTemplateDetails.vue'

import CreateTemplates from '../views/CreateTemplates.vue'

import Activities from '../views/Activities.vue'

// ✅ NEW IMPORT
import LandlordInvoice from '../views/LandlordInvoice.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/Users',
    name: 'Users',
    component: Users,
    beforeEnter: guardMyroute,
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: guardMyroute,
  },
  {
    path: '/Addproperty',
    name: 'Addproperty',
    component: Addproperty,
    beforeEnter: guardMyroute,
  },

  {
    path: '/Addtenant',
    name: 'Addtenant',
    component: Addtenant,
    beforeEnter: guardMyroute,
  },

  {
    path: '/EditLease/:id',
    name: 'EditLease',
    component: EditLease,
    beforeEnter: guardMyroute,
  },

  {
    path: '/edit-property/:id',
    name: 'EditProperty',
    component: EditProperty,
    props: true,
    beforeEnter: guardMyroute,
  },

  {
    path: '/EditTenant/:id',
    name: 'EditTenant',
    component: EditTenant,
    props: true,
    beforeEnter: guardMyroute,
  },

  {
    path: '/EditLandlords/:id',
    name: 'EditLandlords',
    component: EditLandlords,
    props: true,
    beforeEnter: guardMyroute,
  },

  {
    path: '/activities',
    name: 'activities',
    component: Activities,
    props: true,
    beforeEnter: guardMyroute,
  },

  {
    path: '/Attachments/:id',
    name: 'Attachments',
    component: () => import('../views/Attachments.vue'),
    props: (route) => ({
      id: route.params.id,
      collection: route.query.collection || 'properties'
    }),
    beforeEnter: guardMyroute,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/Reports/:id',
    name: 'Reports',
    component: () => import('../views/Reports.vue'),
    props: (route) => ({
      id: route.params.id,
      state: route.query.state,
      collection: route.query.collection || 'properties'
    }),
    beforeEnter: guardMyroute,
    meta: { requiresAuth: true }
  },

  {
    path: '/LeaseReports',
    name: 'LeaseReports',
    component: LeaseReports,
    beforeEnter: guardMyroute,
  },

  {
    path: '/Notes/:id',
    name: 'Notes',
    component: () => import('../views/Notes.vue'),
    props: (route) => ({
      id: route.params.id,
      collection: route.query.collection || 'properties'
    }),
    beforeEnter: guardMyroute,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/Lease',
    name: 'Lease',
    component: Lease,
    beforeEnter: guardMyroute,
  },

  {
    path: '/AddLandlords',
    name: 'AddLandlords',
    component: AddLandlords,
    beforeEnter: guardMyroute,
  },

  {
    path: '/Landlords',
    name: 'Landlords',
    component: Landlords,
    beforeEnter: guardMyroute,
  },

  // ✅ NEW ROUTE — Landlord Invoice
  {
    path: '/LandlordInvoice/:id',
    name: 'LandlordInvoice',
    component: LandlordInvoice,
    props: true,
    beforeEnter: guardMyroute,
    meta: { requiresAuth: true }
  },

  {
    path: '/Addlease',
    name: 'Addlease',
    component: Addlease,
    beforeEnter: guardMyroute,
  },

  {
    path: '/Tenants',
    name: 'Tenants',
    component: Tenants,
    beforeEnter: guardMyroute,
  },

  {
    path: '/AddTenantsExel',
    name: 'AddTenantsExel',
    component: AddTenantsExel,
    beforeEnter: guardMyroute,
  },

  {
    path: '/Finances',
    name: 'Finances',
    component: Finances,
    beforeEnter: guardMyroute,
  },

  {
    path: '/Properties',
    name: 'Properties',
    component: Properties,
    beforeEnter: guardMyroute,
  },

  {
    path: '/CreateTemplates',
    name: 'CreateTemplates',
    component: CreateTemplates,
    beforeEnter: guardMyroute,
  },

  {
    path: '/template',
    name: 'catergory',
    component: Template,
    beforeEnter: guardMyroute,
  },
  {
    path: '/addTemplate',
    name: 'addTemplate',
    component: AddTemplate,
    beforeEnter: guardMyroute,
  },
  {
    path: '/templateName',
    name: 'templateName',
    component: TemplateName,
    beforeEnter: guardMyroute,
  },
  {
    path: '/viewTemplateDetails',
    name: 'viewTemplateDetails',
    component: ViewTemplateDetails,
    beforeEnter: guardMyroute,
  },

  {
    path: '/addUser',
    name: 'AddUser',
    component: AddUser,
    beforeEnter: guardMyroute,
  },

  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },

  {
    path: '/messageUser',
    name: 'MessageUser',
    component: MessageUser,
    beforeEnter: guardMyroute,
  },

  {
    path: '/voiceMessages',
    name: 'VoiceMessages',
    component: VoiceMessages,
    beforeEnter: guardMyroute,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function guardMyroute(to, from, next) {
  var isAuthenticated = false;
  if (localStorage.getItem("email") && localStorage.getItem("password"))
    isAuthenticated = true;
  else
    isAuthenticated = false;
  if (isAuthenticated) {
    next();
  }
  else {
    next('/');
  }
}

export default router